<template>
  <a-card :bordered="false">
    <!-- 検索区域-begin -->
    <search-area
      ref="SearchArea"
      statusType="1"
      parent="HistoryModal"
      @searchQuery="searchQuery(false, false)"
      @updateQueryParam="updateQueryParam"
    ></search-area>
    <!-- 検索区域-end -->

    <!-- table区域-begin -->
    <div>
      <a-alert type="warning" show-icon style="margin-bottom: 10px" class="animate__animated animate__flipInX_disable">
        <template slot="message">
          <span>自行</span>
          <span style="color: var(--color-orange)"> 撤回 </span>
          <span>或者被 </span>
          <span style="color: var(--color-red)"> 驳回 </span>
          <span>的流程，可以在 </span>
          <a
            class="annotate1"
            style="color: var(--color-primary); line-height: 20px; display: inline-block; padding: 0 5px"
            @click="
              $router.push({
                name: 'k00-k0011-TaskManage',
              })
            "
            >待办流程</a
          >
          <span> 中找到并且编辑之后再次申请，</span>
          <span class="annotate2" style="color: var(--color-red)">不必重新发起新的流程 !!!</span>

          <div style="float: right">
            <span style="margin-right: 8px">仅显示我发起的</span>
            <a-switch size="small" v-model="queryParam.showOnlyMe" style="position: relative; top: -1px" />
          </div>
        </template>
      </a-alert>

      <a-table
        ref="table"
        class="action"
        rowKey="processInstanceId"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
        tableLayout="auto"
      >
        <!-- 申請時間 -->
        <div slot="startDate" slot-scope="text, record">
          <span>
            {{ moment(record.startDate).format('YYYY-MM-DD') }}
          </span>
          <span class="note">
            {{ moment(record.startDate).format(' HH:mm:ss') }}
          </span>
        </div>

        <!-- 最近更新時間 -->
        <div slot="endDate" slot-scope="text, record">
          <span>
            {{ moment(record.endDate).format('YYYY-MM-DD') }}
          </span>
          <span class="note">
            {{ moment(record.endDate).format(' HH:mm:ss') }}
          </span>
        </div>

        <span slot="taskStatus" slot-scope="text, record">
          <a-tag color="green" v-if="record.taskStatus == 'disp.flow.end'">{{ $t(record.taskStatus) }}</a-tag>
          <a-tag color="red" v-else-if="record.taskStatus == 'disp.flow.refuse'">{{ $t(record.taskStatus) }}</a-tag>
          <a-tag v-else-if="record.taskStatus == 'disp.flow.cancel'">{{ $t(record.taskStatus) }}</a-tag>
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="handleOpen(record)">{{ $t('disp.flow.detail') }}</a>
          <a-divider type="vertical" />
          <a @click="handleHistory(record.processInstanceId, record.processDefinitionName)">{{
            $t('disp.flow.history')
          }}</a>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <track-modal ref="TrackModal"></track-modal>

    <!-- 申請モーダル：申請フォームを載せる -->
    <apply-modal ref="ApplyModal"></apply-modal>
  </a-card>
</template>

<script>
import { tableMixin } from '@/mixins/tableMixin'
import { flowMixin } from '@/mixins/flowMixin'
import { putAction, postAction, getAction } from '@/api/manage'
import TrackModal from './TrackModal'
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
import SearchArea from './SearchArea'

export default {
  name: 'HistoryModal',
  mixins: [tableMixin, flowMixin],
  components: {
    TrackModal,
    JDictSelectTag,
    SearchArea,
  },
  data() {
    return {
      description: '処理済一覧・終了案件',
      // ログインユーザ情報
      loginUser: this.$store.getters.userInfo,
      showLoadingBySearch: true,
      // テーブルタイトル
      columns: [
        {
          title: this.$t('disp.flow.applyId'),
          //align: 'center',
          //width: 91,
          dataIndex: 'processInstanceId',
          customRender: this.renderProcessInstanceId,
        },
        {
          title: this.renderApplyNameHeader,
          dataIndex: 'processDefinitionName',
          customRender: this.renderApplyName,
        },
        {
          title: this.$t('disp.flow.starter'),
          align: 'center',
          width: 91,
          customRender: this.renderStarter,
        },
        {
          title: this.$t('disp.flow.starterOrg'),
          align: 'left',
          // width: 180,
          dataIndex: 'starterDepartName',
          customRender: this.renderDepartName,
        },
        {
          title: this.$t('disp.flow.startDate'),
          align: 'left',
          dataIndex: 'startDate',
          //scopedSlots: { customRender: 'startDate' },
          customRender: this.renderDate,
        },
        {
          title: this.$t('disp.flow.lastUpdateDate'),
          align: 'left',
          dataIndex: 'endDate',
          //scopedSlots: { customRender: 'endDate' },
          customRender: this.renderDate,
        },
        {
          title: this.$t('disp.status'),
          align: 'center',
          width: 91,
          scopedSlots: { customRender: 'taskStatus' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/flow/history/list',
      },
    }
  },
  computed: {},
  methods: {
    updateQueryParam() {
      this.queryParam = this.$refs.SearchArea ? this.$refs.SearchArea.queryParam : {}
    },
    tagColor(user) {
      return 'blue'
    },
    tagName(user) {
      return user.realname
    },
    handleOpen(record) {
      // 0 下記以外
      // 1 申請ポータル
      // 2 一時保存一覧
      // 3 未処理一覧
      // 4 処理済一覧・進行中案件 or 申請案件一覧・進行中案件
      // 5 処理済一覧・終了案件 or 申請案件一覧・終了案件
      // 6 処理済一覧・非活性案件
      this.$refs.ApplyModal.popupFrom = '5'

      this.$refs.ApplyModal.title = record.processDefinitionName
      this.$refs.ApplyModal.status = record.taskStatus
      this.$refs.ApplyModal.component = record.component
      this.$refs.ApplyModal.procInstId = record.processInstanceId
      this.$refs.ApplyModal.taskId = record.id
      this.$refs.ApplyModal.status = record.taskStatus

      this.$refs.ApplyModal.handleOpen()
    },
    handleHistory(processInstanceId, title) {
      this.$refs.TrackModal.open(processInstanceId, title)
    },
  },
}
</script>
